require('select2');

require('./scripts/common');
require('./scripts/script-delete-register');
require('./scripts/script-rescind-contract');
require('./scripts/script-manifest-action');
require('./scripts/script-impersonate-register');
require('./scripts/script-nf-actions');
require('./scripts/script-paymentr');
require('./scripts/script-dropzone');
require('./scripts/script-datatable');
require('./scripts/script-datatable-report-taxes');

getNumbers = function (string) {
    return string.replace(/[^0-9]/g, '');
};

dd = function () {
    $(arguments).each(function (idx, arg) {
        console.log(idx, arg);
    })
};

$(function () {
    $('[data-toggle="tooltip"]').tooltip();

    $('select#year').on('change', function () {
        window.location.href = $(this).attr('data-url') + '/' + $(this).val() + "#report";
    });

    $('select.select2').select2();
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/app.js